export const CHANGE_RESOLUTION = "Change resolution";
export const CHANGE_SCALE = "Change scale";
export const CHANGE_WIDTH = "Change width";
export const CHANGE_HEIGHT = "Change height";
